import { gmiRequest } from "actions/request";
import { actions, services } from "@ehi/global-marketing-interface";

export const modifyAbort =
    ({ redirect = true } = {}) =>
        (dispatch) =>
            dispatch(
                gmiRequest({
                    action: actions.request({
                        service: services.gma.reservations.modifyAbort,
                    }),
                    loadingOverlay: true,
                    redirect,
                })
            );